import { Navigate, useLocation } from 'react-router-dom';
import { useAuth, hasRole } from '../hooks/useAuth.jsx';

export function ProtectedRoute({ children, role = 'user' }) {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    const redirectTo = role === 'user' ? '/login' : '/staff-login';
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  // Első belépés – kötelező a fiók aktiválása
  if (user.setup_required && role === 'user') {
    return <Navigate to="/beallitas" replace />;
  }

  if (!hasRole(user, role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}
